import { CARREGAR_LOTES_VENDA_SERVER, ATUALIZAR_STATUS_VENDA_LOTE } from "../constants/constants";
import {database} from '../firebase'
import {carregarLotesStore} from '../actions/vendas'
import { doLoad, finishLoad } from "../actions/request";

export default ({dispatch}) => next => action =>{
    if(action.type==CARREGAR_LOTES_VENDA_SERVER){
        database.ref('/lotes/').on('value', (snap)=>{
            dispatch(carregarLotesStore(snap.val()));
        })
    }
    if(action.type==ATUALIZAR_STATUS_VENDA_LOTE){
        dispatch(doLoad())
        database.ref('/lotes/').once('value', snap =>{
            let updates = {};
            updates['/lotes/'] = snap.val();
            updates['/lotes/'][action.id] = {...updates['/lotes/'][action.id], disponibilidade: action.disponibilidade}
            database.ref().update(updates); 
            dispatch(finishLoad())
        })
    }
    next(action);
}



// WEBPACK FOOTER //
// ./src/middlewares/lotes.js